var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVacio = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.106 19.4108L20.0554 13.0472L10.1559 3.14766L3.79225 8.09706L15.106 19.4108ZM17.2269 12.3401L17.934 13.0472L16.5198 14.4614L15.8127 13.7543L17.2269 12.3401ZM15.1056 14.4614L15.8127 15.1685L14.3985 16.5827L13.6914 15.8756L15.1056 14.4614ZM15.4592 10.5723L16.1663 11.2794L14.7521 12.6936L14.0449 11.9865L15.4592 10.5723ZM13.3378 12.6936L14.0449 13.4007L12.6307 14.8149L11.9236 14.1078L13.3378 12.6936ZM13.6914 8.80452L14.3985 9.51162L12.9843 10.9258L12.2772 10.2187L13.6914 8.80452ZM11.5701 10.9258L12.2772 11.6329L10.863 13.0472L10.1559 12.3401L11.5701 10.9258ZM11.9236 7.03675L12.6307 7.74386L11.2165 9.15807L10.5094 8.45096L11.9236 7.03675ZM9.8023 9.15807L10.5094 9.86518L9.0952 11.2794L8.38809 10.5723L9.8023 9.15807ZM10.1559 5.26898L10.863 5.97609L9.44875 7.3903L8.74164 6.6832L10.1559 5.26898ZM8.03454 7.3903L8.74164 8.09741L7.32743 9.51163L6.62032 8.80452L8.03454 7.3903Z",
    fill: "#E91E63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55667 8.27632C2.36151 8.47148 2.36115 8.78791 2.55667 8.98343L14.2197 20.6464C14.4149 20.8416 14.7316 20.8416 14.9268 20.6464L15.6343 19.939C15.8294 19.7438 15.8294 19.427 15.6343 19.2319L3.97124 7.56886C3.77572 7.37335 3.45929 7.3737 3.26413 7.56886L2.55667 8.27632Z",
    fill: "#AD1457"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVacio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Vacio.7eec2776.svg";
export { ForwardRef as ReactComponent };